import React, { Component } from 'react'
import ReactECharts from 'echarts-for-react'
import 'echarts-wordcloud'

class WordCloud extends Component {
    options = (data) => ({
        tooltip: {
            trigger: 'item',
            formatter: (params) => (
                `<div style="color:white;background-color:#102E4A;padding:7px 9px;font-size:15px;">${params.name}</div>
                <div style="padding:10px 15px;font-size:14px;color:#102E4A;display:flex;align-items:center;flex-direction:row;">
                    ${params.marker}
                    ${params.name}
                    <span style="margin-left:12px;font-weight:800;">
                        ${params.value} 
                    </span>
                </div>`
            ),
            extraCssText: 'min-width: 120px;border-radius: 4px;overflow:hidden;',
            padding: 0,
            borderWidth: 0,
            className: 'barTooltip',
        },
        series: [
            {
                type: 'wordCloud',
                shape: 'circle',
                maskImage: this.props.maskImage,
                left: 'center',
                top: 'center',
                width: '100%',
                height: '100%',
                right: null,
                bottom: null,
                sizeRange: [12, 60],
                shrinkToFit: true,
                rotationRange: [0, 0],
                rotationStep: 45,
                gridSize: 8,
                drawOutOfBound: false,
                layoutAnimation: false,
                emphasis: {
                    focus: 'self',
                    textStyle: {
                        shadowBlur: 10,
                        shadowColor: 'rgba(0,0,0,0.5)',
                    },
                },
                data,
            },
        ],
    })

    constructor(props) {
        super(props)
        this.state = {
            blockWordCloud: false,
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleWindowResize)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowResize)
        if (this.timeout) {
            clearTimeout(this.timeout)
        }
    }

    handleWindowResize = () => {
        if (this.timeout) clearTimeout(this.timeout)
        this.setState({ blockWordCloud: true })
        this.timeout = setTimeout(() => {
            this.setState({ blockWordCloud: false })
        }, 300)
    }

    render() {
        const { style, setRef } = this.props
        if (this.state.blockWordCloud || this.props.pauseRender) return null
        return (
            <div className="wordCloudChart" style={{ height: '400px', width: '500px', ...style }}>
                <ReactECharts
                    option={this.options(this.props.data)}
                    className="chart"
                    style={{ height: '100%' }}
                    notMerge
                    ref={(e) => { if (setRef && typeof setRef === 'function') setRef(e) }}
                />
            </div>
        )
    }
}

export default WordCloud
